import { IBondGrossMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_DELTA_SHEKEL_MARKET';

export type IReportGrossDeltaShekelMarketItem = IBondGrossMarketReport & { __isSelected: boolean };
